import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Goals from '../containers/GoalsContainer';
import Footer from './Footer';
import Reflections from '../containers/ReflectionsContainer';
import NavBar from './NavBar';
import Logo from './Logo';
import {
  Container,
  Row,
  Column,
  PageTitle,
  Card,
  TinyText,
  TinyTitle,
  BaseLink
} from './CommonUiComponents';
import Notes from '../containers/NotesContainer';
import ProfileSettings from '../containers/ProfileSettingsContainer';
import findIdByPath from '../utils/findIdByPath';

class Profile extends Component {
  componentDidMount() {
    const {
      fetchBookIfNeeded,
      match: {
        params: { bookId }
      }
    } = this.props;
    window.scroll(0, 0);
    fetchBookIfNeeded(bookId);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { navOpen, book, bookError } = this.props;
    if (
      book !== nextProps.book ||
      bookError !== nextProps.bookError ||
      navOpen !== nextProps.navOpen
    ) {
      return true;
    }

    return false;
  }

  render() {
    const { navOpen, book, bookError, invertedTheme } = this.props;

    if (bookError) return null;

    return (
      <div>
        <NavBar primary>
          {book && (
            <BaseLink to={`/bok/${book.id}`}>
              <Logo size="4.1875rem" />
            </BaseLink>
          )}

          {book && (
            <TinyTitle inverted={invertedTheme && !navOpen}>
              «{book.bookCategory}»
            </TinyTitle>
          )}
          {book && (
            <TinyText italic inverted={invertedTheme && !navOpen}>
              «{book.title}»
            </TinyText>
          )}
        </NavBar>
        <Container>
          <Row>
            <Column small />
            <Column>
              <PageTitle inverted={invertedTheme}>Min side</PageTitle>
            </Column>
          </Row>
          <Row>
            <Column small>
              <Goals />
              <ProfileSettings />
            </Column>
            <Column>
              <Card inverted>
                <Reflections />
              </Card>
              <Card inverted>
                <Notes />
              </Card>
            </Column>
          </Row>
        </Container>
        <Footer inverted={invertedTheme} bookId={findIdByPath()} />
      </div>
    );
  }
}

Profile.propTypes = {
  navOpen: PropTypes.bool.isRequired,
  book: PropTypes.object,
  fetchBookIfNeeded: PropTypes.func.isRequired
};

export default Profile;



// WEBPACK FOOTER //
// ./src/components/Profile.js